import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from "@azure/msal-react";
import { initializeMSAL } from "./Auth/authConfig";

const initializeApp = async () => {
  try {
    
    const msalInstance = await initializeMSAL();
    
    const root = ReactDOM.createRoot(
      document.getElementById('root') as HTMLElement
    );
    
    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </React.StrictMode>
    );
    
    reportWebVitals();

  } catch (error) {
    
    console.error("Failed to initialize MSAL", error);
    const root = ReactDOM.createRoot(
      document.getElementById('root') as HTMLElement
    );
    root.render(
      <div className="error-container">
        <h1>Authentication Error</h1>
        <p>Failed to initialize authentication. Please refresh the page.</p>
        <p>Error details: {(error as Error).message}</p>
      </div>
    );

  }
};

initializeApp();
